import React, { useState } from "react";

export default function FAQ1() {
  const faqs = [
    {
      q: "What is TROGO?",
      a: "TROGO is a transport and logistics platform that allows users to book passenger rides, goods transport vehicles, heavy vehicles, and emergency services from one app."
    },
    {
      q: "How do I book a ride or vehicle?",
      a: "Simply open the TROGO app, choose your service type, enter pickup & drop details, view fare estimate, and confirm the booking."
    },
    {
      q: "Are drivers verified?",
      a: "Yes. Every driver undergoes document verification, identity checks, and admin approval to ensure safety and reliability."
    },
    {
      q: "How is pricing decided?",
      a: "Pricing is transparent and based on distance, vehicle type, and demand. Estimated fare is shown before booking."
    },
    {
      q: "What payment methods are supported?",
      a: "You can pay using UPI, Credit/Debit Cards, NetBanking, and Cash depending on availability in your region."
    },
    {
      q: "Can businesses partner with TROGO?",
      a: "Yes! Transporters can register on the Transporter App to receive bookings and grow their business."
    },
    {
      q: "Do you provide 24/7 support?",
      a: "Support availability depends on region, but we strive to provide assistance whenever needed. Emergency vehicles operate round-the-clock."
    },
    {
      q: "Is my data safe?",
      a: "Absolutely. TROGO follows strict data protection policies and never shares user data with third parties."
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="bg-gray-50">
      
      {/* Hero Section */}
      <div className="relative py-20 bg-gradient-to-r from-trogoBlue to-trogoOrange py-24 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>

        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-h1 md:text-5xl font-extrabold">
            Frequently Asked Questions
          </h1>
          <p className="mt-4 text-body text-white/90 max-w-3xl mx-auto">
            Everything you need to know about TROGO’s transport and logistics platform.
          </p>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-h2 font-bold text-trogoBlue">
            Your Questions — Answered
          </h2>
          <p className="text-gray-600 mt-3">
            If you still have doubts, feel free to contact our support team.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-lg border hover:shadow-xl transition-all"
            >
              <button
                className="w-full flex justify-between items-center p-5 text-left"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-gray-800 text-lg">
                  {item.q}
                </span>

                <span className="text-trogoOrange text-2xl">
                  {openIndex === i ? "−" : "+"}
                </span>
              </button>

              {openIndex === i && (
                <div className="px-5 pb-5 text-gray-600 border-t bg-gray-50 rounded-b-2xl">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Help Box */}
        <div className="mt-14 bg-white shadow-xl border rounded-2xl p-8 text-center max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-trogoBlue">
            Still Need Help?
          </h3>
          <p className="text-gray-600 mt-2">
            Our support team is ready to assist you anytime.
          </p>

          <div className="mt-4 flex justify-center gap-4">
            <a
              href="/contact"
              className="px-6 py-3 rounded-lg bg-trogoBlue text-white font-semibold hover:bg-trogoOrange transition"
            >
              Contact Support
            </a>

            <a
              href="/"
              className="px-6 py-3 rounded-lg border border-trogoBlue text-trogoBlue hover:bg-trogoBlue hover:text-white transition"
            >
              Go to Home
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
